import '../CSS/Skeleton.css';

export const SkeletonLine = (props) => (
    <div className="skeleton line" style={{width: props.width ?? '5.5em'}}></div>
);